import React, { Component } from "react"
import reactStringReplace from "react-string-replace"

export default class MerchantSearchResult extends Component {
  stringReplace = (text, input) => {
    const words = input.split(" ").filter(Boolean)
    const regex = new RegExp("(" + words.join("*|") + ")", "gi")
    return reactStringReplace(text, regex, (match, i) => <span key={match + i}>{match}</span>)
  }

  render() {
    var noResults = (
      <div className="form__section__inner">
        <div className="form__field  no-results">
          <p data-epi-edit="NoResults">{this.props.noResults || "Ingen resultater..."}</p>
        </div>
      </div>
    )

    if (this.props.data && this.props.data.count === 0) {
      return noResults
    } else if (!this.props.data) {
      return ""
    }

    return (
      <div className={"search-result-container--inner"}>
        {this.props.data.docs?.map((merchant, index) => {
          const nameMarkup = this.stringReplace(merchant.Name, this.props.query)
          return (
            <React.Fragment key={index}>
              <a href={merchant.MerchantURL} data-epi-edit="LinkToStore">
                <div className="form__section__inner">
                  <div className="store-logo">
                    <img src={merchant.WebLogoUpload_s ?? merchant.WebLogo} />
                  </div>
                  <div className="store-name">
                    {nameMarkup} {merchant.CustomLocationLabel_s}
                  </div>
                  {merchant.GrabLink_s && merchant.GrabLogoTypeahead_s ? (
                    <div className={"grab-logo"}>
                      <a href={merchant.GrabLink_s} target="_blank" rel="noreferrer">
                        <img src={merchant.GrabLogoTypeahead_s} />
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="store-link">
                    <div data-epi-edit="LinkToStore">{this.props.linkToStore}</div>
                  </div>
                </div>
              </a>
            </React.Fragment>
          )
        })}
      </div>
    )
  }
}
